interface EmptyStateConstants {
  titleTag: keyof JSX.IntrinsicElements;
  title: string;
  description: string;
}

export const EMPTY_STATE_CONSTANTS: EmptyStateConstants = {
  titleTag: 'h2',
  title: 'ma-empty-state-title-font',
  description: 'ma-empty-state-description-font',
};

export const LOGGED_OUT_CONSTANTS: EmptyStateConstants = {
  titleTag: 'h1',
  title: 'ma-logged-out-title-font',
  description: 'ma-logged-out-description-font',
};